<template>
  <div>
    <div v-if="$route.query.confirmSucessful">
      <div class="confirm-together" style="margin-bottom:1.5rem;margin-top:2rem">
      <p style="display: inline-block" v-html="$t('signup.ok', { email: `<span style='color:#3238C4'>${$route.query.email}</span>`})"></p> 
    </div>
      <div style="margin-bottom:1.5rem">
        <h6>{{ $t('signup.modal3') }}</h6>
      </div>
      <div style="margin-bottom:1.5rem">
        <h6 v-if="!inOpenlegal()" style="display: inline-block" v-html="$t('signup.modal4')"></h6>
        <h6 v-else style="display: inline-block" v-html="$t('signup.modal4-openlegal')"></h6>
      </div>
    </div>
    <div v-else>
      <p>{{ $t('account.confirm-account-error') }}</p>
    </div>
  </div>
</template>

<script>
import { BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye } from 'bootstrap-vue'
import { inOpenlegal } from '@/constants/platformNames'

export default {
  components: {
    BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye
  },
  data () {
    return {
			inOpenlegal
    }
  },
  props: {
    email: {
      type: String,
      required: false
    },
    confirmSucessful: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style lang="scss">
.confirm-together {
  p {
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/account/RegisterPostScreen.vue